export class LoginDTO {
    userId: string;
    password: string;
    dealerId: string;
    userName: string;
    token: string;
    isAssetApplicable: string;
    dealerName: string;
    checkHomePage: boolean = false;
    brands: string;
    role:any;
}